<template>
    <div class="managingPeople hp100 bbox " v-loading="loading">
        <el-card>
            <el-row :gutter="20" type="flex" justify="space-between">
                <el-col>
             <el-button style="background:#f59a23"  class="myBtn"
              @click="gotoDetail('')" > 
              <i class="el-icon-plus fw900 f16"></i> 新增</el-button>
                </el-col>
                <el-col>
                    <div class="flex align-center justify-end header-search-box">
                        <el-input
                                placeholder="查询条件"
                                clearable
                                v-model="searchInput"
                                class="header-search-input ml10"
                        >
                            <el-button
                           
                                    slot="append"
                                    icon="el-icon-search"
                                    class="textblue searchBtn"
                                    @click="search()"
                            ></el-button>
                        </el-input>
                    </div>
                </el-col>
            </el-row>
            <!-- 用户列表区域 -->
            <div class="mainBox">
                <div class="leftBox">
         <div :class="{'item':true,'active' : i==activeIndex}" @click="changeActive(i,item.categoryCode)"
          v-for="item,i in categoryList" :key="i">{{item.categoryName}}</div>
                </div>
                <div class="rightBox">
                    <el-table
                    :data="tableData"
                    border
                    fit
                    height="100%"
                    style="width:100%"
                    highlight-current-row
            >
      <el-table-column label="序号" align="center" type="index" >
                    </el-table-column>
                    <el-table-column label="商家编码" align="center"  prop="商家编码" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.merchantCode }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="商家名称" align="center"  prop="商家名称" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.merchantName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="产品编码" align="center"  prop="产品编码" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.productCode }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="产品名称" align="center"  prop="产品名称" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.productName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="类别编码" align="center"  prop="类别编码" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.categoryCode }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="类别名称" align="center"  prop="类别名称" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.categoryName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="序号越大越靠前" align="center"  prop="序号越大越靠前" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.seq }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="正常价格" align="center"  prop="正常价格" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.normalPrice }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="会员价" align="center"  prop="会员价" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.memberPrice }}</span>
                        </template>
                    </el-table-column>
                <el-table-column
                        label="操作"
                        align="center"
                >
                    <template slot-scope="scope">
                        <el-tooltip
                               
                                effect="dark"
                                content="删除"
                                placement="bottom"
                        >
                            <i
                   class="el-icon-delete textblue f16 "
                                    @click="del(scope.row.id)"
                            ></i>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
                </div>
            </div>
            <div class="footerBox">
                <!-- 分页区域 -->
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page.sync="queryInfo.currPage"
                        :page-sizes="[10, 20, 30, 50]"
                        :page-size="queryInfo.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </div>
        </el-card>
    </div>
</template>

<script>
export default {
  data() {
    return {
        activeIndex:0,
     categoryList:[],
      height: window.innerHeight - 256, //表格高度
      value: "",
      searchInput: "",
      tableData: [],
      loading: true,
      // 获取用户列表查询参数对象
      queryInfo: {
        // 当前页数
        currPage: 1,
        // 每页显示多少数据
        pageSize: 20,
        //查询条件
        condition:{
          merchantCode:localStorage.getItem('merchantCode')
        }
      },
      userlist: [],
      total: 0,
      // 添加用户对话框
      addDialogVisible: false,
      // 用户添加
      addUserForm: {
        username: "",
        password: "",
        email: "",
        mobile: "",
      },
      // 修改用户
      editDialogVisible: false,
      editUserForm: {},
      // 分配角色对话框
      setRoleDialogVisible: false,
    };
  },
  created() {
    this.getListData();
    this.getCategory()
  },
  mounted() {
    this.loading = false;

  },
  methods: {
    //条件查询
    search(){
    this.queryInfo.condition.id = this.searchInput;
    this.getListData();
    },
    // 监听 pagesize改变的事件
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.getListData();
    },
    // 监听 页码值 改变事件
    handleCurrentChange(newSize) {
      this.queryInfo.currPage = newSize;
      this.getListData();
    },
    changeActive(index,categoryCode){
        this.activeIndex=index
        this.queryInfo.condition.categoryCode=categoryCode
        this.getListData()
    },
    //跳转到详情
    gotoDetail(id) {
      var  that=this;
      this.$router.push({
        path: "/merchantShangChengIndexProduct/details",
        query: { id: id,currPage:that.queryInfo.currPage,pageSize:that.queryInfo.pageSize},
      });
    },

    // 删除用户
    async del(id) {
      const confirmResult = await this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).catch((err) => err);
      if (confirmResult === "confirm") {
           var that = this;
        that.$http.post("/merchantShangChengIndexProduct/delete" ,{"id":id}).then(function (response) {
          that.$notify.success({
            title: "提示",
            message: "删除成功",
            showClose: true,
          });
          that.getListData();
        });
      }
    },
     getListData() {
        // 获取列表
      var that = this;
      that.$http.post("merchantShangChengIndexProduct/list", that.queryInfo).then(function (response) {
        console.log(response.data.data);
        if (response.data.code == 200) {
          that.total = response.data.data.count;
          that.queryInfo.currPage=response.data.data.currPage
          that.tableData = response.data.data.data;
        }
      });
    },
  async  getCategory(){
 let res=await this.$http.post('merchantShangChengIndexProductCategory/queryList',{merchantCode:localStorage.getItem('merchantCode')})
  this.categoryList=res.data.data
  this.categoryList.unshift({categoryCode:'',categoryName:'全部'})
  },
  },
};
</script>

<style lang="less" scoped>
    .textblue {
        color: #008eff;
    }
    .managingPeople {
    .el-card {
        position: relative;
    .el-select > .el-input {
        width: 200px;
    }
    .header-search-box .header-search-input {
        width: 325px;
    }
    input::placeholder {
        font-size: 12px;
    }
    .handle-btn .el-button.add-column-btn {
        width: 100%;
        font-size: 13px;
        background-color: transparent;
        color: #008eff;
        z-index: 102;
    }
    .footerBox {
        // position: absolute;
        width: 100%;
    }
    }
    }
    /deep/ .el-table{
        margin-top: 0;
    }
.mainBox{
    margin-top: 15px;
    display: flex;
    .leftBox::-webkit-scrollbar{
        width: 0;
    }
    .leftBox{
        display: flex;
        flex-direction: column;
        width: 130px;
        border: 1px solid transparent;
        height: calc(100vh - 200px);
        overflow-y: auto;
    .item{
     user-select: none;
    padding-left: 4px;
    height: 32px;
    width: 106px;
    text-align: left;
    line-height: 32px;
    color: #222;
    font-size: 14px;
    cursor: pointer;
    margin-bottom: 6px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
        }
        .active{
            background: #fff3bf;
        }
    }
    .rightBox{
        display: flex;
        flex: 1;
        width: 600px;
        margin-left: 12px;
        height: calc(100vh - 200px);
    }
}
/deep/ .myBtn{
    background: #f59a23;
    color: #fff;
    border-color: #f59a23;
}
/deep/ .myBtn:hover{
    background: #f59a23;
    color: #fff;
    border-color: #f59a23;
}
</style>

